import { RowNode } from "@bfx/ag-grid-community";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { StringAdapter } from "shared/cubiq-services/adapter/StringAdapter";
import { ScratchPadOrder } from "shared/cubiq-services/model/orders/ScratchPadOrder";

export class FixingDateSCHelper {
  protected localeString: string = "DD-MMM-YY";

  constructor() {}

  retrieveData(order: ScratchPadOrder, columnProperty: string): string {
    if (
      order.requestOrderType != CubiqTS.RequestOrderType.BMARK &&
      order.product != CubiqTS.Product.NDF
    ) {
      return "-";
    }
    let moment: CubiqTS.Moment = this.getDate(order, columnProperty);
    // TODO i18n
    if (moment) {
      if (order.requestOrderType == CubiqTS.RequestOrderType.BMARK) {
        let dateAndTime: string =
          moment.format(this.localeString) + " " + this.getTimeAndZone(order);
        return dateAndTime;
      }
      return moment.format(this.localeString);
    }
    return "-";
  }

  getDate(adaptee: any, columnProperty: string): CubiqTS.Moment {
    let dt: any = adaptee[columnProperty];
    if (CubiqTS.moment.isMoment(dt)) {
      return dt.utc().local();
    } else if (CubiqTS.Long.isLong(dt)) {
      // moment accepts unix milliseconds seconds in this format
      let dtM = CubiqTS.moment((dt as CubiqTS.Long).toNumber());
      return dtM;
    } else if (typeof dt === "string") {
      let dtM = CubiqTS.moment(Number(dt));

      // TODO tz support- cubiq-ts is always UTC
      return dtM;
    } else if (dt && dt.toLocaleDateString) {
      return CubiqTS.moment(dt);
    } else if (dt instanceof CubiqTS.StandardDateImpl) {
      return CubiqTS.moment([dt.year, dt.month - 1, dt.day]);
    }
    return null;
  }
  getTimestamp(order: any, columnProperty: string): number {
    let date = order[columnProperty];
    let dateToBeConverted;
    if (date) {
      if (date instanceof CubiqTS.StandardDateImpl) {
        let minutes: string = order.fixingTime != null ? order.fixingTime.minutes.toString() : "00";
        let hours: string = order.fixingTime != null ? order.fixingTime.hours : "00";
        if (minutes && minutes.length == 1) {
          minutes = "0" + minutes;
        }
        dateToBeConverted = [date.year, date.month - 1, date.day, hours, minutes];
      } else if (CubiqTS.moment.isMoment(date)) {
        dateToBeConverted = date;
      }

      return +CubiqTS.moment(dateToBeConverted).valueOf();
    }
    return 0;
  }

  getTimeAndZone(order: any): string {
    if (order.fixingTime) {
      let mnts: string = order.fixingTime.minutes.toString();
      if (mnts && mnts.length == 1) mnts = "0" + mnts;
      return order.fixingTime.hours + ":" + mnts + " " + order.fixingTime.timeZone;
    }
    return "";
  }

  /**
   * Compare the composite fixing date/time properties of the scratch pad orders - supports both
   * BMs and NDFs
   * @param _value1
   * @param _value2
   * @param node1
   * @param node2
   * @returns
   */
  public compareFixingTimes(_value1, _value2, node1: RowNode, node2: RowNode): number {
    const order1: ScratchPadOrder = node1?.data,
      order2: ScratchPadOrder = node2?.data;
    const date1 = order1.fixingDateMoment?.valueOf() ?? 0;
    const date2 = order2.fixingDateMoment?.valueOf() ?? 0;
    if (
      date1 - date2 == 0 &&
      (order1.orderType === CubiqTS.OrderType.BENCHMARK ||
        order2.orderType === CubiqTS.OrderType.BENCHMARK)
    ) {
      // they have same date but at least one is a benchmark
      if (
        order1.orderType === CubiqTS.OrderType.BENCHMARK &&
        order2.orderType === CubiqTS.OrderType.BENCHMARK
      ) {
        // Both are benchmarks so compare times lexically
        return FixingDateSCHelper.compareStrings(order1.bmFixingTime, order2.bmFixingTime);
      }
      // The one with a fixing time comes first
      return order1.orderType === CubiqTS.OrderType.BENCHMARK ? 1 : -1;
    }
    // Neither are BMs so just compare the dates
    return date1 - date2;
  }

  public static compareStrings(str1: string, str2: string): number {
    if (str1 == null) {
      str1 = "";
    }
    if (str2 == null) {
      str2 = "";
    }
    return str1.localeCompare(str2);
  }
}
